module.exports = __webpack_public_path__ + "static/media/master_card_logo.64524094.svg";